import { DEFAULT_TEMPLATE_INFO } from './Default/pdf';
import { AGILITYIO_TEMPLATE_INFO } from './AgilityIO/pdf';

export const CV_TEMPLATES = [DEFAULT_TEMPLATE_INFO, AGILITYIO_TEMPLATE_INFO];
